<div class="logo-field">
    <img *ngIf="previewUrl" class="logo-preview" [src]="previewUrl" alt="לוגו המוסד">
    <span *ngIf="loading" class="no-logo"><i class="fa fa-spinner fa-spin"></i> טוען לוגו...</span>
    <span *ngIf="!previewUrl && !loading" class="no-logo">לא הועלה לוגו</span>
    <label *ngIf="editable && !loading" class="logo-button" [class.disabled]="busy">
        <i [hidden]="!busy" class="fa fa-spinner fa-spin"></i>
        {{ previewUrl ? 'החלף לוגו' : 'העלה לוגו' }}
        <input type="file" accept="image/png,image/jpeg" [disabled]="busy" (change)="onFileSelected($event)" />
    </label>
    <span *ngIf="sizeError || error" class="logo-error">{{ sizeError || error }}</span>
</div>
